import { Provider }             from 'react-redux'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment }        from '@mui/x-date-pickers/AdapterMoment'
import Beacon4Store from './store/Beacon4Store'
import App          from './App'

export default function Beacon4Performance() {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Provider store={Beacon4Store}>
        <App />
      </Provider>
    </LocalizationProvider>
  )
}